module.exports = __webpack_public_path__ + "img/wh.0498e5d0.jpg";